import { Button, Col, DatePicker, Input, Popconfirm, Row, Select, message } from "antd";
import axios from "axios";
import React, { useState } from "react";
import API_HOST from "../config.js";
import { testProfile } from "./cancelFunction.js";
import SelectAccounts from "./selectAccounts.js";
const { TextArea } = Input;

function ComplaintSuspend_v4(props) {
  const [profileModel, setProfileModel] = useState(testProfile);
  const [time, setTime] = useState(new Date());
  const [accounts, setAccounts] = useState('');
  const [listId, setListId] = useState('');
  const [contents, setContents] = useState([]);
  const [content, setContent] = useState(undefined);
  const [messageApi, contextHolder] = message.useMessage();
  const [mccId, setMccId] = useState('');
  const [mccList, setMccList] = useState([]);
  const [runAll, setRunAll] = useState(false);
  const type = "complaint";
  const content_template = {
    type: type,
    name: 'Nội dung mới',
    content: { // 20 fields
      1: { label: 'End Customer Company Name', value: ''},
      2: { label: 'Email CC', value: ''},
      3: { label: 'Website', value: ''},
      4: { label: 'Sample keywords from one of your campaigns', value: ''},
      5: { label: 'Street address', value: ''},
      6: { label: 'ZIP/Postal code', value: ''},
      7: { label: 'City', value: ''},
      8: { label: 'Please inform the preferred time we can call to reach you', value: ''},
      9: { label: 'Who pays for the Google Ads account', value: ''},
      10: { label: 'Please provide a brief description of your business', value: ''},
      11: { label: 'Information regarding client-agency relationship', value: ''},
      12: { label: 'Domain ownership', value: ''},
      13: { label: 'Summary of the issue', value: ''},

      14: { label: 'Do you have single or multiple Google Ads account', value: '', placeholder: 'VD: Single ...'},
      15: { label: 'Are you advertising your own business', value: '', placeholder: 'VD: Yes, No'},

      16: { label: 'Please select your billing country', value: '', placeholder: 'VD: us, il ...'},
      17: { label: 'What country(ies) does your business serve', value: '', placeholder: 'VD: us, il ...'},
      18: { label: 'Please provide a phone number we can call to reach you', value: '', placeholder: 'VD: US, IL ...'},
      19: { label: 'Phone Number', value: ''},
      20: { label: 'Your Google Ads payment option', value: ''},
    }
  }


  const complaint = async () => {
    let body = {
      jobName: `complaint-suspend-${props.profile.name}`,
      time: time,
      data: {
        profileId: props.profile.id,
        profile: props.profile,
        content: content,
        accounts: accounts,
        mccId: mccList?.length > 0 ? mccList[0] : mccId,
        listId: listId,
        runAll: runAll,
      },
    };
    axios
      .post(`${API_HOST}/api/schedule/complaint`, body)
      .then((res) => messageApi.success("Đã đặt lệnh"))
      .catch((e) => {
        console.log("🚀 ~ complaint-suspend ~ e:", e);
        messageApi.error(e.response.data);
      });
  };

  const newContent = () => {
    saveContent(content_template,
      (saved) => {
        setContent(saved)
        setContents([...contents, saved]);
      }
    );
  };
  const editContent = () => {
    saveContent(content,
      (saved) => {
        setContents(contents.map(c => c._id === saved._id ? saved : c));
      }
    );
  };
  const removeContent = () => {
    let id = content._id;
    axios
    .delete(`${API_HOST}/api/contents/${id}` )
    .then(() => {
      messageApi.success("Đã xóa");
      setContent(undefined);
      setContents(contents.filter(c => c._id !== id));
    })
    .catch((e) => {
      console.log("🚀 ~ removeContent ~ e:", e)
      messageApi.error(e.response.data);
    });

  };

  const saveContent = async (content, onDone) => {
    axios
    .post(`${API_HOST}/api/contents`, content )
    .then((saved) => {
      messageApi.success("Saved");
      if(onDone) {
        onDone(saved.data);
      }
    })
    .catch((e) => {
      console.log("🚀 ~ saveContent ~ e:", e)
      messageApi.error(e.response.data);
    });
  };

  const getContents = async () => {
    axios
    .get(`${API_HOST}/api/contents?type=${type}`)
    .then((res) => {
      if (res.data) {
        setContents(res.data);
      }
    })
    .catch((e) => {
      messageApi.error("Không thể lấy DS Nội dung");
    });
  };

  const onOpenChange = (open) => {
    if (open) {
      axios
        .get(`${API_HOST}/api/profiles/${props.profile.id}`)
        .then((res) => {
          if (res.data) {
            setProfileModel(res.data[0]);
          }
        })
        .catch((e) => {
          messageApi.error("Không thể lấy thông tin Profile");
        });
        getContents();
    }
  };

  const onOk = (value) => {
    setTime(value? value.toDate() : new Date());
  };

  const onSearch = (value) => {
    console.log('search:', value);
  };

  return (
    <>
      {contextHolder}
      <Popconfirm
        rootClassName="width-500"
        onOpenChange={onOpenChange}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Kháng Tài Khoản"
        description={
          <>
              {profileModel?.errorMsg?.length> 0  &&
                <label style={{ color: "red", border: '1px solid red'}}>
                  <strong>{profileModel?.errorMsg}</strong></label>
              }
              <label>Chọn Giờ: </label>
              <DatePicker showTime onOk={onOk} />
              <br />
              <Row gutter={16}>
                <Col span={12}>
                  <div style={{display:'flex', justifyContent:'flex-start', alignItems: 'center', gap: '10px'}}>
                  <label>Chọn Nội dung: </label>
                  <Select
                    style={{width: '300px'}}
                    showSearch
                    value={content?._id}
                    placeholder="Chọn nội dung"
                    onChange={(id) => setContent(contents.find(c => c._id === id))}
                    optionFilterProp="label"
                    onSearch={onSearch}
                    options={contents.map((c) => ({
                      label: c.name,
                      value: c._id
                    }))}
                  />
                  <Button type="primary" onClick={newContent}>
                    Thêm
                  </Button>

                </div>
    
                <div style={{marginTop: '10px',padding: '6px', minHeight: '400px', overflow: 'auto', border: '1px solid #ccc', borderRadius: '5px'}}>
                  
                  {content && 
                    <div key={content._id+'title'} style={{display:'flex', justifyContent:'space-between', marginBottom: '10px'}}>
                      <div style={{flex: '20%'}}><strong>Tiêu đề: </strong></div>
                      <Input 
                        defaultValue={content.name}
                        onChange={(e) => {
                          content.name = e.target.value;
                        }}/>
                    </div>
                  }
                    {content && content.content 
                      && Object.keys(content.content).map((key, i) => {
                        let tempContent = content;
                        let field = tempContent.content[key];
                        return (
                          <div key={content._id+i} style={{display:'flex', justifyContent:'space-between', marginBottom: '5px'}}>
                            <div style={{flex: '80%'}}>{field.label}</div>
                            <Input 
                              placeholder={field.placeholder}
                              defaultValue={field.value}
                              onChange={(e) => {
                                field.value = e.target.value;
                                setContent(tempContent);
                              }} 
                            />
                          </div>
                        )
                    })}
                </div>
                <div style={{display:'flex', justifyContent:'space-between', gap: '10px', marginTop: '10px'}}>
                  <Popconfirm
                      title={`Xóa ND: ${content?.name}`}
                      onConfirm={removeContent}
                      okText="Yes"
                      cancelText="No"
                  >
                    <Button danger>
                        Xóa
                    </Button>
                  </Popconfirm>
          
                  <Button type="primary" onClick={editContent}>
                      Lưu
                  </Button>
        
                </div>
                </Col>
                <Col span={12}>
                  <label><b>Nhập MCC ID (Nếu có nhiều TK MCC):</b></label>
                  <br />
                  <Input
                    style={{ width: 200 }}
                    placeholder="MCC ID"
                    onChange={(e) => setMccId(e.target.value)}
                  />
                  <br></br>
                  <label> Hoặc: </label>
                  <SelectAccounts selectAccounts={profileModel?.selectAccounts} max={1}
                      onSelected={(selected) => setMccList(selected)}
                  />
                  <br></br>
                  <br></br>
                  {/* <Checkbox checked={runAll} onChange={e => setRunAll(e.target.checked)}>
                      <b>Chạy Toàn Bộ TK con</b>
                  </Checkbox> */}
                  <TextArea rows={10} 
                      value={listId} 
                      placeholder="Hoặc: Danh sách ID ..."
                      onChange={(e) => setListId(e.target.value)} 
                  />
                </Col>
              </Row>
              

          </>
        }
        onConfirm={() => complaint()}
      >
        <Button type="primary" style={{backgroundColor:'green'}}>Kháng TK</Button>
      </Popconfirm>
    </>
  );
}
export default ComplaintSuspend_v4;